import React from 'react';
import { SocketProvider } from '../contexts/SocketContext';
import { CartProvider } from '../contexts/CartContext';

const AuthenticatedProviders = ({ children }) => (
  <SocketProvider>
    <CartProvider>
      {children}
    </CartProvider>
  </SocketProvider>
);

export default AuthenticatedProviders;
